module.exports = __webpack_public_path__ + "static/img/man-side.0df94e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST/man-side.png
// module id = mwS/
// module chunks = 3